var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bj-tags-list-20220225" },
    [
      _vm._l(_vm.cptOrderTagCodeList, function (tagCode, index) {
        return _c("BjTag", {
          key: index,
          attrs: {
            size: _vm.size,
            color: (
              _vm.BJ_TAGS.find(function (e) {
                return e.labelCode == tagCode
              }) || {}
            ).textColor,
            text: (
              _vm.BJ_TAGS.find(function (e) {
                return e.labelCode == tagCode
              }) || {}
            ).textContent,
            closable:
              _vm.closable &&
              !(
                _vm.BJ_TAGS.find(function (e) {
                  return e.labelCode == tagCode
                }) || {}
              ).systemLabelFlag,
          },
          on: {
            close: function ($event) {
              return _vm.handleCloseTag(tagCode)
            },
          },
        })
      }),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }